import { createReducer } from '@reduxjs/toolkit';
import { getMovementsIds } from 'pages/AllMovements/AllMovements.config';
import {
  IGetMovement,
  TypeGessstMovement,
} from 'pages/AllMovements/AllMovements.types';
import { apiRequestSuccess } from 'services/api/api.actions';
import {
  getBookingOperationsEndpoint,
  getLitPlayListEndpoint,
  getLotteryEndpoint,
} from 'services/movements/movements.config';
import { isGetMovementsResourceId } from 'services/movements/movements.helpers';
import {
  BillOperations,
  GntnPlayLis,
  LitPlayList,
  Movement,
} from 'services/movements/movements.types';

const initialState = {
  all: {} as Record<string, Movement>,
  poker: {} as Record<string, Movement>,
  cardGames: {} as Record<string, Movement>,
  casinoAndSlots: {} as Record<string, Movement>,
  quickGames: {} as Record<string, Movement>,
  lotto: {} as Record<string, Movement>,
  bingo: {} as Record<string, Movement>,
  recharges: {} as Record<string, Movement>,
  widrawals: {} as Record<string, Movement>,
  // ...initialStateMovementsById,
  bookedOperations: {} as Record<string, BillOperations>,
  lotteries: {} as Record<string, GntnPlayLis>,
  scratchAndWin: {} as Record<string, LitPlayList>,
  totalPages: 0,
};

const movementsReducer = createReducer(initialState, (builder) =>
  builder.addCase(apiRequestSuccess, (state, action) => {
    const { payload } = action;

    const movements = payload?.response?.data?.responseObject;
    const totalPages = payload?.response?.data?.totalSize;

    if (isGetMovementsResourceId(payload.resourceId)) {
      const key: TypeGessstMovement =
        getMovementsIds[
          payload.resourceId.replace(/\D/g, '') === '4'
            ? 0
            : payload.resourceId.replace(/\D/g, '')
        ];
      if (Array.isArray(movements)) {
        const x = Object.fromEntries(
          movements.map((movementRecord: Movement, index) => [
            `${movementRecord.tsn}_${index}`,
            movementRecord,
          ]),
        );
        state[key] = x as IGetMovement | any;
      } else {
        state[key] = {};
      }
      state.totalPages = totalPages;
    }

    const lotteries = payload?.response?.data?.gntnPlayList;

    if (payload.resourceId === getLotteryEndpoint) {
      if (Array.isArray(lotteries)) {
        state.lotteries = Object.fromEntries(
          lotteries.map((lotteriesRecord: GntnPlayLis, index) => [
            `${lotteriesRecord.playId}_${index}`,
            lotteriesRecord,
          ]),
        );
      }
    }

    const scratchAndWin = payload?.response?.data?.litPlayList;

    if (payload.resourceId === getLitPlayListEndpoint) {
      if (Array.isArray(scratchAndWin)) {
        state.scratchAndWin = Object.fromEntries(
          scratchAndWin.map((scratchAndWinRecord: LitPlayList, index) => [
            `${scratchAndWinRecord.transactionId}_${index}`,
            scratchAndWinRecord,
          ]),
        );
      }
    }

    const bookedOperations = payload?.response?.data?.billOperations;

    if (payload.resourceId === getBookingOperationsEndpoint) {
      if (Array.isArray(bookedOperations)) {
        state.bookedOperations = Object.fromEntries(
          bookedOperations.map(
            (bookedOperationsRecord: BillOperations, index) => [
              `${bookedOperationsRecord.tsn}_${index}`,
              bookedOperationsRecord,
            ],
          ),
        );
      }
    }
  }),
);

export default movementsReducer;
